import { useCallback, useState } from "react";
import { getUserId } from "src/utils";

import {
  loadFavouriteReportTypes,
  saveFavouriteReportTypes,
} from "./favouriteReportTypes";

export const useFavouriteReportTypes = () => {
  const [favourites, setFavourites] = useState(() =>
    loadFavouriteReportTypes(getUserId()),
  );

  const toggleFavourite = useCallback((value: string) => {
    setFavourites(current => {
      const next = current.includes(value)
        ? current.filter(item => item !== value)
        : [...current, value];
      saveFavouriteReportTypes(getUserId(), next);
      return next;
    });
  }, []);

  return { favourites, toggleFavourite };
};
